import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import $ from "jquery";
import notify from "../../../../assets/svg/notifyActive.svg";
import {
  rightBarClose,
  setNotifyCountFn,
} from "../../../../redux/action/Action";
import noNotify from "../../../../assets/img/no_notify2.png";
import {
  GET_NOTIFICATION,
  PUT_UPDATE_NOTIFICATION,
} from "../../../../helpers/endpointService";
import Moment from "moment";
import axios from "axios";
import { PulseLoader } from "react-spinners";
import { logoutFunction } from "../../../custom/commonFunction";

export default function Notifications({ rightbarOpen, rightbarId }) {
  const dispatch = useDispatch();
  const userId = localStorage.getItem("UserId");
  const [messages, setmessages] = useState();
  const [isPropertyLoader, setPropertyLoader] = useState(false);
  const [isPropertyFailed, setPropertyFailed] = useState(false);

  useEffect(() => {
    setPropertyLoader(true);
    setPropertyFailed(false);
    if (rightbarOpen) {
      $("body").addClass("scrollhide");
    }

    fetchData();
  }, [rightbarId]);

  const fetchData = async () => {
    let propApiUrl = `${GET_NOTIFICATION}?userId=${userId}`;
    await axios
      .get(propApiUrl)
      .then((response) => {
        setPropertyLoader(false);
        if (response?.status === 200) {
          setmessages(response.data?.reverse());
        }
      })
      .catch((err) => {
        setPropertyLoader(false);
        setPropertyFailed(true);
        logoutFunction(err?.response?.status);
      });
  };

  const removeNotification = async (id, type) => {
    setPropertyLoader(true);
    if (id) {
      if (type === "clearOne") {
        let notifyRemoveApiUrl = `${PUT_UPDATE_NOTIFICATION}?userId=${userId}&notificationId=${id}&isClearAll=false`;
        await axios
          .put(notifyRemoveApiUrl)
          .then((response) => {
            if (response?.status === 200) {
              if (response.data === true) {
                fetchData();
                dispatch(setNotifyCountFn());
              }
            }
          })
          .catch((err) => {
            setPropertyLoader(false);

            logoutFunction(err?.response?.status);
          });
      } else if (type === "clearAll") {
        let notifyRemoveApiUrl = `${PUT_UPDATE_NOTIFICATION}?userId=${userId}&isClearAll=true`;
        await axios
          .put(notifyRemoveApiUrl)
          .then((response) => {
            if (response?.status === 200) {
              if (response.data === true) {
                fetchData();
                dispatch(setNotifyCountFn());
              }
            }
          })
          .catch((err) => {
            setPropertyLoader(false);

            logoutFunction(err?.response?.status);
          });
      }
    }
  };

  const close = () => {
    dispatch(rightBarClose());
    $("body").removeClass("scrollhide");
  };

  return (
    <>
      <div
        className={`viewbar ${rightbarOpen ? "viewbarOpen" : ""} ${
          isPropertyLoader ? "overFlowHidden" : ""
        }`}
      >
        {isPropertyLoader && (
          <div className="loader-new-1">
            <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
          </div>
        )}

        {isPropertyFailed && (
          <div className="loader-new-1">
            <span>Loading failed</span>
          </div>
        )}

        <div className="viewMain viewNofity">
          <div className="notifyBtnBox">
            <div className="viewTitle">
              <span>Notifications</span>
              {!isPropertyLoader && (
                <span className="close mt-2" onClick={close}>
                  ✕
                </span>
              )}
            </div>

            {messages?.length > 0 && (
              <div className="mt-4 mr-2">
                <div className="viewButton">
                  <img alt="" src={notify} />
                  <span onClick={() => removeNotification(1, "clearAll")}>
                    Clear all
                  </span>
                </div>
              </div>
            )}
          </div>

          {messages && messages?.length > 0
            ? messages?.map((msg, index) => {
                return (
                  <div className="notifySection mt-3" key={index}>
                    <div className="notifyMsg side-scroll">
                      <div className="row">
                        <div className="col-9 font-weight-bold">
                          {msg.documentNumber}
                        </div>
                        <div
                          className="col-3 text-right cursor-pointer"
                          onClick={() =>
                            removeNotification(msg.notificationId, "clearOne")
                          }
                        >
                          ✕
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-9">{msg.documentName}</div>
                        <div className="col-3 text-right">
                          {msg.createdTime}
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-8">{msg.body}</div>
                        <div className="col-4 text-right">
                          {msg.createdDate
                            ? Moment(msg.createdDate).format("DD-MMM-YYYY")
                            : ""}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            : messages && (
                <div style={{ textAlign: "center", marginTop: "120px" }}>
                  <img
                    alt="No notification"
                    src={noNotify}
                    width={230}
                    style={{ opacity: 0.2 }}
                  />
                </div>
              )}
        </div>
      </div>
    </>
  );
}
